import * as z from "zod";

const loopzIntegrationSummary = z.object({
  enabled: z.boolean(),
  hasApiKey: z.boolean(),
  merchantId: z.string().optional(),
  merchantName: z.string().optional(),
  programId: z.string().optional(),
  programCurrency: z.string().optional(),
  cardDesignId: z.string().optional(),
  personalMessage: z.string().optional(),
  creditReason: z.string().optional(),
  useShopifyFulfillmentLocation: z.boolean(),
});

export type LoopzIntegrationSummary = z.infer<typeof loopzIntegrationSummary>;

export const getLoopzIntegration = {
  name: "getLoopzIntegration" as const,
  input: z.object({}),
  output: z.object({ loopzIntegration: z.optional(loopzIntegrationSummary) }),
};

export type GetLoopzIntegrationOutput = z.infer<
  typeof getLoopzIntegration.output
>;

export const setLoopzIntegration = {
  name: "setLoopzIntegration" as const,
  input: z.object({
    enabled: z.boolean(),
    apiKey: z.string().min(1),
    cardDesignId: z.string().optional(),
    personalMessage: z.string().optional(),
    creditReason: z.string().optional(),
    useShopifyFulfillmentLocation: z.boolean().optional(),
  }),
  output: z.object({
    merchantName: z.string().optional(),
    programCurrency: z.string().optional(),
    currencyMismatch: z.boolean(),
  }),
};

export const updateLoopzIntegration = {
  name: "updateLoopzIntegration" as const,
  input: z.object({
    enabled: z.boolean().optional(),
    apiKey: z.string().min(1).optional(),
    cardDesignId: z.string().optional(),
    personalMessage: z.string().optional(),
    creditReason: z.string().optional(),
    useShopifyFulfillmentLocation: z.boolean().optional(),
  }),
  output: z.object({
    merchantName: z.string().optional(),
    programCurrency: z.string().optional(),
    currencyMismatch: z.boolean(),
  }),
};

export const disconnectLoopzIntegration = {
  name: "disconnectLoopzIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};

export const testLoopzConnection = {
  name: "testLoopzConnection" as const,
  input: z.object({ apiKey: z.string().min(1).optional() }),
  output: z.object({
    success: z.boolean(),
    merchantName: z.string().optional(),
    programCurrency: z.string().optional(),
    programName: z.string().optional(),
    currencyMismatch: z.boolean(),
    errorMessage: z.string().optional(),
  }),
};
